import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class UserService {
    private BASE_URL = environment.apiUrl + 'api/user';

    constructor(private http: HttpClient) { }
    updateUserProfile( data: any): Observable<any> {
        const url = `${this.BASE_URL}/update_profile`;
        return this.http.put(url, data);
    }


    getUserById(userId: string): Observable<any> {
    const url = `${this.BASE_URL}/profile/${userId}`;
    return this.http.get(url);
    }


}
